import React from 'react';
import MobileDetect from 'mobile-detect';

function Share() {

    const deviceDetect = () => {
        let type = new MobileDetect(window.navigator.userAgent)
        switch (type.os()) {
            case  'AndroidOS':
                return window.location.href = "https://play.google.com/store/apps/details?id=com.letsup.hamyap";
            case 'iOS':
                return window.location.href = "https://apps.apple.com/us/app/ham-yap/id6447787659"
            default:
                return ''
        }
    }

    return (
        <div>
            {deviceDetect()}
        </div>
    )
}

export default Share;